/* Media and Surface specs per product, keyed by handle. */
window.WORK_SPECS = {
 "everything-in-its-wrong-place-36-x-36-in": {
  "media": "Mixed media and plaster",
  "surface": "Stretched canvas"
 },
 "our-bones-are-barely-held-together-by-our-bodies-8-5-x-10-5-in": {
  "media": "Mixed media, plaster, burlap and paper",
  "surface": "Wood"
 },
 "a-day-s-worth-of-minutes-or-something-similar-36-x-36-in": {
  "media": "Mixed media and plaster",
  "surface": "Stretched canvas"
 },
 "untitled": {
  "media": "Mixed media",
  "surface": "Stretched canvas"
 },
 "leather-weather-20-x-20-in": {
  "media": "Mixed media and plaster",
  "surface": "Stretched canvas"
 },
 "alabaster-oblongata-20-x-20-in": {
  "media": "Mixed media and plaster",
  "surface": "Stretched canvas"
 },
 "oh-my-lonely-bones-20-x-20-in": {
  "media": "Mixed media, wire and clay",
  "surface": "Stretched canvas"
 },
 "everything-is-an-approximation-30-x-30-in": {
  "media": "Mixed media and plaster",
  "surface": "Stretched canvas"
 },
 "with-age-comes-loss-12-x-12-in": {
  "media": "Mixed media and plaster",
  "surface": "Stretched canvas"
 },
 "coordinates-8-x-8-in": {
  "media": "Mixed media and plaster",
  "surface": "Wood"
 },
 "wicker-8-x-8-in": {
  "media": "Mixed media and plaster",
  "surface": "Stretched canvas"
 },
 "threadbare-10-x-10-in": {
  "media": "Mixed media and plaster",
  "surface": "Wood"
 },
 "arrowheads-petals-24x-24-in": {
  "media": "Mixed media and plaster",
  "surface": "Stretched canvas"
 },
 "squaring-thr-circle-36-x-36-in": {
  "media": "Mixed media and plaster",
  "surface": "Stretched canvas"
 },
 "unnatural-nature-10-x-10-in": {
  "media": "Mixed media, clay and resin",
  "surface": "Wood"
 },
 "weave-framed-8-x-8-in": {
  "media": "Mixed media, clay,",
  "surface": "Wood"
 },
 "bronze-bomb-10-x-10-in": {
  "media": "Mixed media and plaster",
  "surface": "Stretched canvas"
 },
 "give-me-crumbs-20-x-20-in": {
  "media": "Mixed media and plaster",
  "surface": "Stretched canvas"
 },
 "finally-a-portrait-of-my-father-48-x-36-in": {
  "media": "Mixed media",
  "surface": "Stretched canvas"
 },
 "cowboy-gay-36-x-36-in": {
  "media": "Mixed media",
  "surface": "Stretched canvas"
 },
 "gay-panic-36-x-36-in": {
  "media": "Acrylic",
  "surface": "Stretched canvas"
 },
 "gimme-36-x-48-in": {
  "media": "Mixed media",
  "surface": "Stretched canvas"
 },
 "good-boyl-36-x-36-in": {
  "media": "Mixed media",
  "surface": "Stretched canvas"
 },
 "_-begat-_-36-x-36-in": {
  "media": "Mixed media",
  "surface": "Stretched canvas"
 },
 "i-couod-be-a-morning-person-if-i-wanted-to-30-x-24-in": {
  "media": "Acrylic",
  "surface": "Stretched canvas"
 },
 "no-really-i-m-fine-20-x-16-in": {
  "media": "Mixed media",
  "surface": "Stretched canvas"
 },
 "crown-12-x-12-in": {
  "media": "Acrylic",
  "surface": "Stretched canvas"
 },
 "trust-fall-36-x-48-in": {
  "media": "Mixed media",
  "surface": "Stretched canvas"
 },
 "babel-48-x-36-in": {
  "media": "Mixed media",
  "surface": "Stretched canvas"
 },
 "the-tiny-secrets-we-keep-36-x-36-in": {
  "media": "Mixed media",
  "surface": "Stretched canvas"
 },
 "derivation-n-36-x-36-in": {
  "media": "Mixed media",
  "surface": "Stretched canvas"
 },
 "a-practice-in-saying-goodbye-36-x-36-in": {
  "media": "Mixed media",
  "surface": "Stretched canvas"
 },
 "recessive-excessive-18-x-24-in": {
  "media": "Mixed media",
  "surface": "Paper"
 },
 "withdrawn-36-x-36-in": {
  "media": "Acrylic",
  "surface": "Stretched canvas"
 },
 "osmosis-36-x-36-in": {
  "media": "Acrylic",
  "surface": "Stretched canvas"
 },
 "above-and-below-36-x-36-in": {
  "media": "Acrylic",
  "surface": "Paper"
 },
 "hidden-agenda-36-x-36-in": {
  "media": "Mixed media",
  "surface": "Stretched canvas"
 },
 "tidal-36-x-48-in": {
  "media": "Acrylic",
  "surface": "Stretched canvas"
 },
 "untitled-36-x-36-in": {
  "media": "Mixed media",
  "surface": "Stretched canvas"
 },
 "were-having-weather-36-x-48-in": {
  "media": "Mixed media",
  "surface": "Stretched canvas"
 },
 "ghost-leather-36-x-48-in": {
  "media": "Acrylic",
  "surface": "Stretched canvas"
 },
 "untitled-24-x-36-in": {
  "media": "Mixed media",
  "surface": "Stretched canvas"
 },
 "u-up-5-5-x-8-5-inches": {
  "media": "Mixed media",
  "surface": "Paper"
 },
 "the-joneses-at-least-we-have-each-other-right-36-x-36-in": {
  "media": "Mixed media",
  "surface": "Stretched canvas"
 },
 "imaginary-atx-home-sweet-home-9-x-12-in": {
  "media": "Mixed media",
  "surface": "Paper"
 },
 "imaginary-atx-murica-9-x-11-in": {
  "media": "Mixed media",
  "surface": "Paper"
 },
 "randy-bitch-24-x-48-in": {
  "media": "Mixed media",
  "surface": "Stretched canvas"
 },
 "ghost-1-36-x-48-in": {
  "media": "Acrylic",
  "surface": "Stretched canvas"
 },
 "trisha-the-maneater-36-x-36-in-1": {
  "media": "Mixed media",
  "surface": "Stretched canvas"
 },
 "how-36-x-48-in": {
  "media": "Mixed media",
  "surface": "Stretched canvas"
 },
 "uber-pool-not-like-other-boys-48-x-36-in": {
  "media": "Mixed media",
  "surface": "Stretched canvas"
 },
 "whoopsie-daisy-36-x-36-in": {
  "media": "Mixed media",
  "surface": "Stretched canvas"
 },
 "meteorite-36-x-36-in": {
  "media": "Mixed media",
  "surface": "Stretched canvas"
 },
 "is-he-you-know-24-x-24-in": {
  "media": "Mixed media",
  "surface": "Stretched canvas"
 },
 "air-wind-water-earth-36-x-48-in": {
  "media": "Mixed media",
  "surface": "Stretched canvas"
 },
 "don-t-remember-to-forget-30-x-24-in": {
  "media": "Acrylic",
  "surface": "Stretched canvas"
 },
 "oleander-30-x-40-in": {
  "media": "Mixed media",
  "surface": "Stretched canvas"
 },
 "i-miss-you-36-x-36-in": {
  "media": "Mixed media",
  "surface": "Stretched canvas"
 },
 "all-the-king-s-men-i-and-ii-16-x-12in": {
  "media": "Mixed media",
  "surface": "Stretched canvas"
 },
 "anamnesis-24x-24-in": {
  "media": "Acrylic",
  "surface": "Stretched canvas"
 },
 "in-memoriam-30-x-24-in": {
  "media": "Acrylic",
  "surface": "Stretched canvas"
 },
 "your-apartment-on-34th-st-the-day-we-got-snowed-in-and-drank-moscato-and-you-got-angry-and-i-fell-in-love-with-you-10-x-10-in": {
  "media": "Mixed media",
  "surface": "Stretched canvas"
 },
 "just-say-when-20-x-20-in": {
  "media": "Mixed media",
  "surface": "Stretched canvas"
 },
 "cc-nyc-1-2-8-x-8-in": {
  "media": "Mixed media",
  "surface": "Wood"
 },
 "one-day-you-re-here-the-next-day-you-re-40-x-30-inh": {
  "media": "Mixed media",
  "surface": "Stretched canvas"
 },
 "untitled-30-x-40-in": {
  "media": "Mixed media and plaster",
  "surface": "Stretched canvas"
 },
 "like-a-snake-molts-its-skin-9-x-12-in": {
  "media": "Mixed media and plaster",
  "surface": "Paper"
 },
 "holding-space-holding-pattern-36-x-36-in": {
  "media": "Mixed media and plaster",
  "surface": "Stretched canvas"
 },
 "tributaries-30-x-22-in": {
  "media": "Mixed media and plaster",
  "surface": "Paper"
 },
 "designer-remains-8-x-8-in": {
  "media": "Acrylic, paper, fabric, wire and plaster",
  "surface": "Wood"
 },
 "when-my-sea-has-dried-and-all-thats-left-is-deset-40-x-30-in": {
  "media": "Acrylic, plaster, paper, plastic and wire",
  "surface": "Stretched canvas"
 },
 "most-everyone-is-mad-here-30-x-40-in": {
  "media": "Mixed media",
  "surface": "Stretched canvas"
 },
 "a-bull-walking-the-desert-36-x-36-in": {
  "media": "Mixed media",
  "surface": "Stretched canvas"
 },
 "a-storm-cloud-moving-in-36-x-36-in": {
  "media": "Mixed media",
  "surface": "Stretched canvas"
 },
 "after-a-decade-s-worth-of-drought-36-x-36-in": {
  "media": "Mixed media and plaster",
  "surface": "Stretched canvas"
 },
 "cerulean-36-x-36-in": {
  "media": "Mixed media",
  "surface": "Stretched canvas"
 },
 "cowboys-do-cry-36-x-36-in": {
  "media": "Mixed media",
  "surface": "Stretched canvas"
 },
 "cumulonimbus-48-x-36-in": {
  "media": "Mixed media",
  "surface": "Stretched canvas"
 },
 "flowers-from-s-fault-line-30-x-30-in": {
  "media": "Mixed media, plaster, and paper",
  "surface": "Stretched canvas"
 },
 "how-i-imagine-marfa-tx-although-i-ve-never-been-47-x-47-in": {
  "media": "Mixed media",
  "surface": "Stretched canvas"
 },
 "marlboro-man-shablam-36-x-36-in": {
  "media": "Mixed media",
  "surface": "Stretched canvas"
 },
 "palomino-36-x-24-in": {
  "media": "Mixed media and plaster",
  "surface": "Stretched canvas"
 },
 "primitive-desert-pixels-12-x-12-in": {
  "media": "Mixed media and plaster",
  "surface": "Stretched canvas"
 },
 "primitive-desert-pixels-12-x-12in": {
  "media": "Mixed media and plaster",
  "surface": "Stretched canvas"
 },
 "strata-36-x-36-in": {
  "media": "Mixed media",
  "surface": "Stretched canvas"
 },
 "the-desert-is-drawing-me-to-it-16-x-20-in": {
  "media": "Mixed media and clay",
  "surface": "Stretched canvas"
 },
 "weekend-drives-through-east-austin-i-36-x-36-in": {
  "media": "Mixed media",
  "surface": "Stretched canvas"
 },
 "where-sand-meets-sea-10-x-10-in": {
  "media": "Mixed media, clay and resin",
  "surface": "Stretched canvas"
 }
};
